import React from 'react';
import { TrendingUpIcon, TrendingDownIcon, MinusIcon } from '@hero/web-icons';
import { cn } from '@hero/web-lib';

export interface GrowthIndicatorProps {
  /** Growth percentage value */
  growth: number | null | undefined;
  /** Label to show next to the indicator (e.g. "vs last week") */
  growthLabel?: string;
  className?: string;
}

/**
 * Small growth indicator with trending arrow and percentage.
 * Green for positive, red for negative, gray for neutral/zero.
 */
export const GrowthIndicator: React.FC<GrowthIndicatorProps> = ({
  growth,
  growthLabel,
  className,
}) => {
  if (growth === null || growth === undefined) {
    return null;
  }

  const isPositive = growth > 0;
  const isNegative = growth < 0;

  const colorClass = isPositive ? 'text-green-600' : isNegative ? 'text-red-500' : 'text-gray-400';

  const displayValue = `${isPositive ? '+' : ''}${Math.round(growth)}%`;

  return (
    <div className={cn('flex items-center gap-1', className)}>
      {isPositive ? (
        <TrendingUpIcon className={cn('h-3 w-3', colorClass)} />
      ) : isNegative ? (
        <TrendingDownIcon className={cn('h-3 w-3', colorClass)} />
      ) : (
        <MinusIcon className={cn('h-3 w-3', colorClass)} />
      )}
      <span className={cn('text-xs font-medium', colorClass)}>
        {displayValue}
        {growthLabel && <span className="text-gray-400 ms-1">{growthLabel}</span>}
      </span>
    </div>
  );
};
